let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class CategoriesFilterController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }
}

CategoriesFilterController.$inject = inject;

export default CategoriesFilterController;




/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-filter.controller.js
 **/